import { API_URL, JobArtifactsResponse, JobWithArtifacts } from '../types';
import {apiGet} from "./apiClient";

/**
 * Fetch artifacts for a specific job
 */
export async function fetchJobArtifacts(jobId: string): Promise<JobArtifactsResponse> {
  const response = await apiGet(`${API_URL}/api/jobs/${jobId}/artifacts`);
  if (!response.ok) {
    throw new Error('Failed to fetch job artifacts');
  }
  return response.json();
}

/**
 * Download a specific artifact file with authentication
 */
export async function downloadArtifact(jobId: string, artifactPath: string): Promise<void> {
  const url = `${API_URL}/api/jobs/${jobId}/artifacts/download?path=${encodeURIComponent(artifactPath)}`;
  
  // Use apiGet to include authentication headers
  const response = await apiGet(url);
  
  if (!response.ok) {
    throw new Error('Failed to download artifact');
  }
  
  // Get the blob from response
  const blob = await response.blob();
  
  // Extract filename from Content-Disposition header or use the artifact path
  let filename = artifactPath.split('/').pop() || 'download';
  const contentDisposition = response.headers.get('Content-Disposition');
  if (contentDisposition) {
    const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition);
    if (matches != null && matches[1]) {
      filename = matches[1].replace(/['"]/g, '');
    }
  }
  
  // Create a temporary link and trigger download
  const downloadUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = downloadUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  
  // Clean up the temporary URL
  window.URL.revokeObjectURL(downloadUrl);
}

/**
 * Fetch all jobs with their artifacts (for the dedicated Artifacts page)
 * Uses the new /api/artifacts endpoint that efficiently returns only jobs with artifacts
 */
export async function fetchAllArtifacts(): Promise<JobWithArtifacts[]> {
  const response = await apiGet(`${API_URL}/api/artifacts`);
  if (!response.ok) {
    throw new Error('Failed to fetch artifacts');
  }
  const jobs = await response.json();
  return jobs;
}
